import logoServi from './logo/LogoServi.png';
const LogoFull = () => {
  return <img src={logoServi} height={"40px"} />;
};
export default LogoFull;